import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { analyticsTrack } from '../../../analyticsUtils';

function KeywordSearchInput({
  name,
  submenuTitle,
  selectionData,
  handleChange,
  setSelectionState,
}) {
  return (
    <Fragment>
      <div className="subcontent-title">
        {submenuTitle === 'Role' && 'Search by'}
        {' '}
        {submenuTitle}
      </div>
      <div className="keyword-search-container">
        <input
          type="text"
          className="form-control"
          placeholder={`Type ${submenuTitle}s`}
          value={selectionData[name][submenuTitle] || ''}
          onChange={(event) => {
            if (selectionData[name][submenuTitle]
            && selectionData[name][submenuTitle].length >= 2) {
              analyticsTrack(`Filtered by ${submenuTitle}`, { location: 'Search Index' });
            }
            handleChange(name, submenuTitle, event.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setSelectionState(selectionData);
            }
          }}
        />
        <button className="btn" onClick={() => setSelectionState(selectionData)}>
          <i className="fas fa-search" />
        </button>
      </div>
    </Fragment>
  );
}

KeywordSearchInput.propTypes = {
  name: PropTypes.string.isRequired,
  submenuTitle: PropTypes.string.isRequired,
  selectionData: PropTypes.instanceOf({}).isRequired,
  handleChange: PropTypes.func.isRequired,
  setSelectionState: PropTypes.func.isRequired,
};

export default KeywordSearchInput;
